import _slicedToArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { me as i, w as s } from "./abstract-base-8edf0a84-e11d45a3.js";
import { T, _ as p, s as r } from "./directive-daf4e9b6-abc0af54.js";
import { x as f, S as l } from "./directive-helpers-336ae7bb-f6343f09.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var c = T( /*#__PURE__*/function (_p) {
  _inherits(_class, _p);
  function _class(t) {
    var _this;
    _classCallCheck(this, _class);
    if (_this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, t)), t.type !== r.PROPERTY && t.type !== r.ATTRIBUTE && t.type !== r.BOOLEAN_ATTRIBUTE) throw Error("The `live` directive is not allowed on child or event bindings");
    if (!f(t)) throw Error("`live` bindings can only contain a single expression");
    return _possibleConstructorReturn(_this);
  }
  _createClass(_class, [{
    key: "render",
    value: function render(t) {
      return t;
    }
  }, {
    key: "update",
    value: function update(t, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        e = _ref2[0];
      if (e === i || e === s) return e;
      var n = t.element,
        o = t.name;
      if (t.type === r.PROPERTY) {
        if (e === n[o]) return i;
      } else if (t.type === r.BOOLEAN_ATTRIBUTE) {
        if (!!e === n.hasAttribute(o)) return i;
      } else if (t.type === r.ATTRIBUTE && n.getAttribute(o) === e + "") return i;
      return l(t), e;
    }
  }]);
  return _class;
}(p));
export { c as m };